import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import AdminDashboardPage from './pages/AdminDashboardPage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import DebugLogPage from './pages/DebugLogPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import UpdatePasswordPage from './pages/UpdatePasswordPage';
import TemplateEditPage from './pages/TemplateEditPage';
import { LayoutProvider } from './context/LayoutContext';
import { AuthProvider, RequireAuth } from './context/AuthContext';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LayoutProvider>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/" element={<Layout />} />
            <Route path="/admin" element={<LoginPage />} />
            <Route path="/admin/signup" element={<SignUpPage />} />
            <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
            <Route path="/admin/update-password" element={<UpdatePasswordPage />} />
            
            {/* Protected Admin Routes */}
            <Route
              path="/admin/dashboard"
              element={
                <RequireAuth>
                  <AdminLayout>
                    <AdminDashboardPage />
                  </AdminLayout>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/logs"
              element={
                <RequireAuth>
                  <AdminLayout>
                    <DebugLogPage />
                  </AdminLayout>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/templates/:id"
              element={
                <RequireAuth>
                  <AdminLayout>
                    <TemplateEditPage />
                  </AdminLayout>
                </RequireAuth>
              }
            />
          </Routes>
        </LayoutProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;